{
  "buttons/add.Label": "Add",
  "buttons/cancel.Label": "Cancel",
  "buttons/delete.Label": "Delete",
  "buttons/create.Label": "Create",
  "buttons/save.Label": "Save",
  "buttons/confirm.Label": "Confirm",
  "buttons/close.Label": "Close",
  "buttons/search.Label": "Search",
  "buttons/send.Label": "Send",
  "buttons/continue.Label": "Continue",
  "buttons/back.Label": "Back",

  "labels/search.Label": "Search",
  "labels/pagination/showResults.Label": "Show Results",

  "input/search.Placeholder": "Search by your phrase",

  "titles/create-new.Label": "Create new",
  "titles/edit.Label": "Edit",
  "titles/image.Placeholder":  "Add image",
  "labels/tables.Loading": "Loading results...",
  "labels/tables.NoResults": "No results",
  "labels/tables.MoreNoResults": "There is no data to preview.",
  "labels/tables.ChangePhrase": "Please change the search phrase.",
  "labels/tables.ResetFilters": "reset filters",

  "forms/required.Label": "Mandatory field",

  "mandator/terminals/terminal/terminal-ots-qr/downloadModal.specificSeats.syntaxTooltip.Text": "Examples: 5/12 for row 5 seat 12, 12L/5 for row 12L seat 5, or a row token for the whole row. Separate entries with commas.",
  "mandator/terminals/terminal/terminal-ots-qr/downloadModal.backToPreview.Label": "Done - back to preview",
  "mandator/terminals/terminal/terminal-ots-qr/downloadModal.seatMap.Label": "Pick seats on the seat map",
  "mandator/terminals/terminal/terminal-ots-qr/downloadModal.seatMap.hint.Text": "Click a seat to add or remove it · click a row number to select the whole row"
}
